import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import Topbar from "../../components/common/Topbar";
import MobileLogo from "../../components/common/MobileLogo";
import Sidebar from "../../components/common/Sidebar";

const ReportScreen = (props) => {
  const [showTopbar, setShowTopbar] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [changeIcon, setChangeIcon] = useState(false);

  const handleShowTopbar = () => {
    setShowTopbar(!showTopbar);
  };
  const handleShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };
  const handleChangeIcon = () => {
    setChangeIcon(!changeIcon);
  };

  const sidebarRef = useRef();
  useEffect(() => {
    let clickToCloseSidebar = (e) => {
      if (sidebarRef.current.contains(e.target)) {
        setShowSidebar(false);
      }
    };

    document.addEventListener("mousedown", clickToCloseSidebar);
    return () => {
      document.removeEventListener("mousedown", clickToCloseSidebar);
    };
  }, []);
  return (
    <>
      <MobileLogo
        handleShowTopbar={handleShowTopbar}
        changeIcon={changeIcon}
        handleChangeIcon={handleChangeIcon}
        handleShowSidebar={handleShowSidebar}
      />

      <Sidebar
        showSidebar={showSidebar}
        handleShowSidebar={handleShowSidebar}
      />
      <Topbar showTopbar={showTopbar} />

      <div className="pc-container" ref={sidebarRef}>
        <div className="pcoded-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="page-header-title">
                    <h5 className="m-b-10">Reports</h5>
                  </div>
                </div>
                <div className="col-md-6 text-end">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={"/dashboard"}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">Reports</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h4>Admissions</h4>

              <div className="row">
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/center-wise-admissions"}>
                      Franchisee wise Admissions
                    </Link>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/course-wise-admissions"}>
                      Course wise Admissions
                    </Link>
                  </div>
                </div>
                {/* <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/all-admissions"}>All Admissions</Link>
                  </div>
                </div> */}
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/old-admissions"}>Old Admission Status</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-sm-12">
              <h4>Royalty</h4>
              <div className="row">
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/center-wise-royalty"}>
                      Franchisee wise Royalty
                    </Link>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* <div className="row mt-5">
            <div className="col-sm-12">
              <h4>Revenue</h4>
              <div className="row">
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/center-wise-revenue"}>
                      Center wise Revenue
                    </Link>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/course-wise-revenue"}>
                      Course wise Revenue
                    </Link>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="link-item">
                    <Link to={"/reports/all-revenue"}>All Revenue</Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </>
  );
};

export default ReportScreen;
